// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/priorities/kv
 *
 * Key-value list of priorities for dropdown selects.
 * Wire shape: `dados: Priorities_KvRow[]` — emitted directly as `dados`.
 */
import type { Priorities_KvRow } from './Priorities_KvRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Priorities_KvResponseDados = Priorities_KvRow[];

export type Priorities_KvResponse = ApiResponse<Priorities_KvResponseDados>;

registerResponseContract('Priorities_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
